import { Box, Button }                from "@mantine/core";
import { Menu }                       from "@mantine/core";
import React, { useEffect, useState } from "react";

import { PrimaryButton } from "_components/atoms/button";
import Typography        from "_components/atoms/typography";
import useStyles         from "_styles/pages/blogs/tagsDialog";

const TagsDialog = ( { anchorEl, id, open, placement, setOpen, tags, selectedTags, onSelect } ) => {
	const { classes }                         = useStyles ( undefined, { name: "styles" } );
	const [ tentativeTags, setTentativeTags ] = useState ( [] );

	useEffect ( () => {
		if ( open )
			setTentativeTags ( selectedTags );
	}, [ open ] );

	const handleTagClick = tag => {
		const arrayIncludesTag = tentativeTags?.find ( el => el.id === tag.id );

		if ( arrayIncludesTag ) {
			const filteredTentativeTags = tentativeTags?.filter ( item => item.id !== tag.id );

			setTentativeTags ( filteredTentativeTags );

			return;
		}

		setTentativeTags ( prevTentativeTags => [ ...prevTentativeTags, tag ] );
	};

	const handleSaveClick = () => {
		const tagsList = [ ...selectedTags ];

		tentativeTags.forEach ( tag => {
			const isSelectedTag = selectedTags?.find ( el => el.id === tag.id );

			if ( isSelectedTag === undefined )
				tagsList.push ( tag );
		} );
		setTentativeTags ( tagsList );
		setOpen ( false );

		onSelect ( tagsList );
	};

	return (
		<Menu
			transition
			anchorEl  = { anchorEl }
			id        = { id }
			// opened = { open }
			placement = { placement }
			radius    = { "lg" }
		>
			<Menu.Target>

				<Button aria-describedby = { id }
					className               = { classes.addTagButton }
					color                   = "gray"
					radius                  = "lg"
					size                    = "lg"
					type                    = "button"
				>
					<Typography
						color = { "white" }
						title = "Add Tag +"
					/>
				</Button>
			</Menu.Target>

			<Menu.Dropdown>
				<Box className = { classes.popperStyles }
					sx            = { { border: 1, p: 1, bgcolor: "background.paper" } }
				>
					<div className = { classes.tagsWrapper }>
						{tags.map ( tag => {

							const isSelected = tentativeTags?.find ( el => el.id === tag.id );

							return (
								<div key   = { tag.tagId }
									className = { classes.tagName }
									onClick   = { () => {
										handleTagClick ( tag );
									} }
									style     = { isSelected ? { background: "linear-gradient(to bottom, #126bd5 0%, #439aff 100%)" } : null }
								>
									<Typography
										className = { classes.tagTitle }
										title     = { tag?.name }
									/>
								</div>
							);
						} )}
					</div>

					<div className = { classes.tagButtonsWrapper }>
						{/* <button className = { classes.cancelTagsButton }>
									Cancel

								</button> */}

						<PrimaryButton
							className = { classes.saveTagsButton }
							onClick   = { () => handleSaveClick () }
							title     = "Save"
						/>

					</div>
				</Box>
			</Menu.Dropdown>

		</Menu>
	);
};

export default TagsDialog;